import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Slide } from 'react-reveal'

//components
import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Icon from '../../../../components/ui/Icon/Icon'
import OtpForm from '../../../../components/home/OtpForm/OtpForm'
import OtpResendForm from '../../../../components/home/OtpResendForm/OtpResendForm'
import DisplayPhotoForm from '../../../../components/home/DisplayPhotoForm/DisplayPhotoForm'
import UpdateProfilePageForm from '../UpdateProfilePageForm/UpdateProfilePageForm'
import {
  DetailPageContainer,
  Header,
  ReturnIcon,
  Title,
  Content,
  Description,
  FormWrapper,
  PermissionLabel,
  MainPage,
  DisplayImage,
  ConfirmTitle,
  BlockActionButton,
  StyledLink,
  SubTitleCenter,
} from './UpdateProfilePage.style'

//services
import validateOtp from '../../../../services/validation/OTP'
import validateProfile from '../../../../services/validation/Profile'
import validateDisplayPhoto from '../../../../services/validation/DisplayPhoto'

//data
import { MAIN } from '../../../../services/data/profilePages.json'
import {
  UPDATE as UPDATE_RECOVERY,
  VERIFY_UPDATE,
} from '../../../../services/data/accountRecoverySteps.json'
import {
  STEP_DEFAULT,
  STEP_UPLOAD,
  STEP_CROPPED,
} from '../../../../services/data/uploadAvatarSteps.json'

const STEP_UPDATE_FORM = null
const STEP_MOBILE_CONFIRM = 0
const STEP_OTP_VALIDATE = 5
const STEP_UPLOAD_AVATAR = 10

class UpdateProfilePage extends React.Component {
  state = {
    updateProfileStep: null,
    updateProfileToken: '',
    newMobileNumber: '',
    errorMessage: '',
    resendData: {},
    avatarState: STEP_DEFAULT,
    recoveryMode: false,
  }

  componentDidMount() {
    const { recoveryStep } = this.props
    const recoveryMode =
      recoveryStep === UPDATE_RECOVERY || recoveryStep === VERIFY_UPDATE
    this.setState({ recoveryMode })
  }

  componentWillUnmount() {
    const { setRecoveryStep } = this.props
    setRecoveryStep(0)
  }

  handleAvatarUpload = () => {
    this.setState({
      avatarState: STEP_UPLOAD,
    })
  }

  handleAvatarCrop = () => {
    this.setState({
      avatarState: STEP_CROPPED,
    })
  }

  showDetailPage = data => {
    this.setState({
      selectedMessage: data,
    })
  }

  closeDetailPage = () => {
    this.setState({
      selectedMessage: null,
    })
  }

  backToMain = () => {
    this.setState({
      updateProfileStep: STEP_UPDATE_FORM,
    })
  }

  changePage = page => {
    this.setState({
      updateProfileStep: page,
    })
  }

  showOtpPage = () => {
    this.setState({
      updateProfileStep: STEP_OTP_VALIDATE,
    })
  }

  onCameraClick = () => {
    this.changePage(STEP_UPLOAD_AVATAR)
  }

  recoverySubmitCallback = () => {
    this.changePage(STEP_MOBILE_CONFIRM)
  }

  updateStateCallback = data => {
    this.setState({ ...data })
  }

  getUpdateMobileCallback = () => {
    const {
      doUpdateProfile,
      accessToken,
      primaryInfo,
      setAccessToken,
      setPrimaryInfo,
      setProfileModalPage,
    } = this.props
    const { recoveryMode } = this.state
    if (recoveryMode) {
      const {
        setRecoveryRequestId,
        setRecoveryStep,
        recoveryRequestId,
        doUpdateMobile,
      } = this.props
      return doUpdateMobile({
        setRecoveryRequestId,
        setRecoveryStep,
        recoveryRequestId,
        callback: this.recoverySubmitCallback,
      })
    } else
      return doUpdateProfile({
        accessToken,
        primaryInfo,
        setAccessToken,
        setPrimaryInfo,
        setProfileModalPage,
        updateStateCallback: this.updateStateCallback,
      })
  }

  redirectToThirdParty = async (redirectUri, code) => {
    if (typeof window !== undefined && window.location && redirectUri) {
      window.location.href = await (redirectUri + (code ? `?code=${code}` : ''))
    }
  }

  getUpdateVerifyCallback = () => {
    const { recoveryMode, updateProfileToken } = this.state
    const {
      accessToken,
      setPrimaryInfo,
      setAccessToken,
      setRecoveryRequestId,
      recoveryRequestId,
      firebaseMessagingToken,
      setRecoveryStep,
      setProfileModalPage,
      displayProfileModal,
      doSubscribeToFirebaseMessaging,
      doVerifyUpdateMobile,
      location,
      doVerifyOTPUpdateProfile,
      saveAccessToken,
    } = this.props
    if (recoveryMode) {
      return doVerifyUpdateMobile({
        setPrimaryInfo,
        setAccessToken,
        setRecoveryRequestId,
        recoveryRequestId,
        firebaseMessagingToken,
        setRecoveryStep,
        setProfileModalPage,
        displayProfileModal,
        doSubscribeToFirebaseMessaging,
        saveAccessToken,
        searchString: location.search,
        redirectToThirdParty: this.redirectToThirdParty,
      })
    } else
      return doVerifyOTPUpdateProfile({
        accessToken,
        setAccessToken,
        setPrimaryInfo,
        setProfileModalPage,
        updateProfileToken,
        saveAccessToken,
      })
  }

  getUpdateResendCallback = () => {
    const { doResendOTPUpdateProfile } = this.props
    const { recoveryMode, updateProfileToken } = this.state
    if (recoveryMode) {
      const {
        setRecoveryRequestId,
        recoveryRequestId,
        doResendUpdateMobile,
      } = this.props
      return doResendUpdateMobile({
        setRecoveryRequestId,
        recoveryRequestId,
      })
    } else
      return doResendOTPUpdateProfile({
        updateProfileToken,
      })
  }

  getOtpNotNowCallback = () => {
    const { recoveryMode } = this.state
    if (recoveryMode) return () => this.changePage(STEP_UPDATE_FORM)
    else return this.backToMain
  }

  setAvatarState = state => {
    this.setState({
      avatarState: state,
    })
  }

  render() {
    const {
      updateProfileStep,
      newMobileNumber,
      avatarState,
      recoveryMode,
    } = this.state
    const {
      accessToken,
      setProfileModalPage,
      primaryInfo,
      setPrimaryInfo,
      emailVerificationStatus,
      // recoveryStep,
      doSubmitAvatar,
      push,
      displayProfileModal,
    } = this.props
    const {
      firstName,
      lastName,
      avatarUrl,
      email,
      mobileNumber,
      facebookId,
      googleId,
      appleId,
    } = primaryInfo || {}
    const disableEmailField = facebookId || googleId || appleId

    const updateMobileCallback = this.getUpdateMobileCallback()
    const updateVerifyCallback = this.getUpdateVerifyCallback()
    const updateResendCallback = this.getUpdateResendCallback()
    const otpNotNowCallback = this.getOtpNotNowCallback()

    const ConfirmationPage = ({ show }) => {
      return (
        <Slide right duration={200}>
          <DetailPageContainer show={show}>
            {!!show && (
              <>
                <Content>
                  <DisplayImage />
                  <ConfirmTitle>
                    Need to change your mobile number?
                  </ConfirmTitle>
                  <Description>
                    All vouchers and information related to your old mobile
                    number will be transferred to {newMobileNumber}.
                  </Description>
                  <Description>Would you like to proceed?</Description>
                  <BlockActionButton
                    variant="primary"
                    onClick={this.showOtpPage}
                  >
                    Yes
                  </BlockActionButton>
                  <StyledLink onClick={otpNotNowCallback}>Not Now</StyledLink>
                </Content>
              </>
            )}
          </DetailPageContainer>
        </Slide>
      )
    }

    const DetailPage = ({ show }) => {
      return (
        <>
          <Slide right duration={200}>
            <DetailPageContainer show={show}>
              {!!show && (
                <>
                  <Header>
                    <ReturnIcon
                      onClick={() => this.changePage(STEP_MOBILE_CONFIRM)}
                    >
                      <Icon name="slide-left" />
                    </ReturnIcon>
                    <Title hasExitButton> Update Profile</Title>
                  </Header>
                  <Content>
                    <SubTitleCenter>Verify mobile number</SubTitleCenter>
                    <Description>
                      You will receive a One-Time PIN (OTP) on your registered
                      mobile number ending in{' '}
                      <span>{newMobileNumber.slice(-4)}</span>.
                    </Description>
                    <FormWrapper>
                      <AccessibleForm
                        initialValues={{}}
                        validate={validateOtp}
                        onSubmit={updateVerifyCallback}
                        component={OtpForm}
                        action="/a/otp/submit"
                        method="post"
                      />
                    </FormWrapper>
                    <PermissionLabel>
                      Did not receive code?{' '}
                      <AccessibleForm
                        initialValues={{}}
                        onSubmit={updateResendCallback}
                        component={OtpResendForm}
                        action="/a/otp/resend"
                        method="post"
                      />
                    </PermissionLabel>
                  </Content>
                </>
              )}
            </DetailPageContainer>
          </Slide>
        </>
      )
    }

    return (
      <>
        <MainPage show={updateProfileStep === STEP_UPDATE_FORM}>
          <Header>
            {!recoveryMode && (
              <ReturnIcon onClick={() => setProfileModalPage(MAIN)}>
                <Icon name="slide-left" />
              </ReturnIcon>
            )}
            <Title hasExitButton={!recoveryMode}>Update Profile</Title>
          </Header>
          <Content withBackground>
            <Description>
              Please make sure your Zing membership details are updated, so you
              receive the latest offers and deals at Ayala Malls.
            </Description>
            <AccessibleForm
              initialValues={{
                firstName,
                lastName,
                email,
                mobileNumber,
              }}
              validate={validateProfile}
              onSubmit={updateMobileCallback}
              component={UpdateProfilePageForm}
              componentProps={{
                disableEmailField,
                emailVerificationStatus,
                onCameraClick: this.onCameraClick,
                avatarUrl,
                recoveryForm: recoveryMode,
                push,
                displayProfileModal,
              }}
              action="/a/profile/update"
            />
          </Content>
        </MainPage>
        <ConfirmationPage show={updateProfileStep === STEP_MOBILE_CONFIRM} />
        <DetailPage show={updateProfileStep === STEP_OTP_VALIDATE} />
        <Slide right duration={200}>
          <DetailPageContainer show={updateProfileStep === STEP_UPLOAD_AVATAR}>
            {updateProfileStep === STEP_UPLOAD_AVATAR && (
              <>
                <Header>
                  <ReturnIcon
                    onClick={() => {
                      this.setState({
                        avatarState: STEP_DEFAULT,
                      })
                      this.changePage(STEP_UPDATE_FORM)
                    }}
                  >
                    <Icon name="slide-left" />
                  </ReturnIcon>
                  <Title>Update Profile</Title>
                </Header>
                <Content>
                  <AccessibleForm
                    initialValues={{
                      avatarUrl,
                    }}
                    isInitialValid={!avatarUrl}
                    validate={validateDisplayPhoto}
                    onSubmit={doSubmitAvatar({
                      accessToken,
                      setPrimaryInfo,
                      setAvatarState: this.setAvatarState,
                      changePage: this.changePage,
                    })}
                    component={DisplayPhotoForm}
                    componentProps={{
                      submitLabel: 'Update',
                      onAvatarUpload: this.handleAvatarUpload,
                      onAvatarCrop: this.handleAvatarCrop,
                      showSubmitButton: avatarState === STEP_CROPPED,
                    }}
                    action="/a/avatar"
                    method="post"
                  />
                </Content>
              </>
            )}
          </DetailPageContainer>
        </Slide>
      </>
    )
  }
}

UpdateProfilePage.defaultProps = {
  primaryInfo: {},
  doUpdateProfile: () => {},
  doSubmitAvatar: () => {},
  doResendOTPUpdateProfile: () => {},
  doVerifyOTPUpdateProfile: () => {},
}

UpdateProfilePage.propTypes = {
  primaryInfo: PropTypes.object,

  doUpdateProfile: PropTypes.func,
  doSubmitAvatar: PropTypes.func,
  doResendOTPUpdateProfile: PropTypes.func,
  doVerifyOTPUpdateProfile: PropTypes.func,
}

export default UpdateProfilePage
